export const INSTAGRAM_HASHTAG_COLOR = '#1FA1FF';
export const IG_DM_BUTTON_TITLE_MAX = 80;
export const INSTAGRAM_CAROUSEL_MIN_ITEMS = 2;
export const INSTAGRAM_CAROUSEL_MAX_ITEMS = 10;
export const INSTAGRAM_CAROUSEL_RATIO_MIN = 0.8;
export const INSTAGRAM_CAROUSEL_RATIO_MAX = 1.91;
export const INSTAGRAM_CAROUSEL_RATIO_STDDEV_LIMIT = 0.05;
export const INSTAGRAM_CAROUSEL_ALLOWED_MIME_TYPES = [
    'image/jpeg',
    'video/mp4',
    'video/quicktime',
];
export const INSTAGRAM_CAROUSEL_ASPECT_RATIOS = [
    { label: '1:1', value: 1 },
    { label: '4:3', value: 4 / 3 },
    { label: '16:9', value: 16 / 9 },
];
export const INSTAGRAM_CAROUSEL_ASPECT_RATIO_LABELS = INSTAGRAM_CAROUSEL_ASPECT_RATIOS.map(r => r.label);
export function validateInstagramCarouselComposition(items) {
    if (items.length < INSTAGRAM_CAROUSEL_MIN_ITEMS || items.length > INSTAGRAM_CAROUSEL_MAX_ITEMS) {
        return {
            ok: false,
            message: `Carousel must have between ${INSTAGRAM_CAROUSEL_MIN_ITEMS} and ${INSTAGRAM_CAROUSEL_MAX_ITEMS} items.`,
        };
    }
    const ratios = [];
    for (let idx = 0; idx < items.length; idx++) {
        const item = items[idx];
        const mimeType = item.mimeType ?? undefined;
        if (!mimeType || !INSTAGRAM_CAROUSEL_ALLOWED_MIME_TYPES.includes(mimeType)) {
            return {
                ok: false,
                message: `Carousel item ${idx + 1}: unsupported media type "${mimeType ?? 'unknown'}". ` +
                    'Use JPEG images or MP4/MOV videos.',
            };
        }
        const ratio = item.ratio ?? undefined;
        if (ratio == null) {
            return {
                ok: false,
                message: `Carousel item ${idx + 1}: missing aspect ratio. Re-upload the image.`,
            };
        }
        if (ratio < INSTAGRAM_CAROUSEL_RATIO_MIN || ratio > INSTAGRAM_CAROUSEL_RATIO_MAX) {
            return {
                ok: false,
                message: `Carousel item ${idx + 1}: aspect ratio ${ratio.toFixed(2)} outside the supported ` +
                    `range (${INSTAGRAM_CAROUSEL_RATIO_MIN}–${INSTAGRAM_CAROUSEL_RATIO_MAX}).`,
            };
        }
        ratios.push(ratio);
    }
    const mean = ratios.reduce((sum, r) => sum + r, 0) / ratios.length;
    const variance = ratios.reduce((sum, r) => sum + (r - mean) ** 2, 0) / ratios.length;
    if (Math.sqrt(variance) > INSTAGRAM_CAROUSEL_RATIO_STDDEV_LIMIT) {
        return {
            ok: false,
            message: 'Carousel items must share an aspect ratio between 4:5 and 1.91:1.',
        };
    }
    return { ok: true };
}
//# sourceMappingURL=instagram.const.js.map